<template>
    <span>
        <v-dialog v-model="editorShownReserve" width="850">
            <!-- Begin:Content:Mode:update --------------------------------- -->
            <v-card v-if="editorMode === 'update'" style="border: 2px solid orange;">
                <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                    <i style="font-size:20px; color: orange;" class="b-fa b-fa-exchange-alt"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} ({{ editorMode.toUpperCase() }})
                </v-card-title>

                <v-card-text class="pa-5">
                    <datetime v-model="startDate" label="Reserve - from:" disabled="false" disabledTime="false" ref="startTimer" />
                    <datetime v-model="endDate" label="Reserve  - to:" disabled="false" disabledTime="false" ref="endTimer" />

                    <datetime v-model="startDateSleep" label="Sleep - from:" disabled="false" ref="startTimerSleep" />
                    <datetime v-model="endDateSleep" label="Sleep  - to:" disabled="false" ref="endTimerSleep" />
                </v-card-text>

                <v-card-text class="pa-5">
                    <comment-textarea v-model="dutyComment" label="Reserve Comment:" maxlength="300" />
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownReserve = false">Cancel</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_ReserveUpdate"> Save</v-btn>
                </v-card-actions>
            </v-card>



            <!-- Begin:Content:Mode:create --------------------------------- -->
            <v-card  v-if="editorMode === 'create'" style="border: 2px solid orange;">
                <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                    <i style="font-size:20px; color: orange;" class="b-fa b-fa-exchange-alt"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} ({{ editorMode.toUpperCase() }})
                </v-card-title>

                <v-card-text class="pa-5">
                    <datetime v-model="startDate" label="Reserve - from:" disabled="false" disabledTime="false" ref="startTimer" />
                    <datetime v-model="endDate" label="Reserve  - to:" disabled="false" disabledTime="false" ref="endTimer" />

                    <datetime v-model="startDateSleep" label="Sleep - from:" disabled="false" ref="startTimerSleep" />
                    <datetime v-model="endDateSleep" label="Sleep  - to:" disabled="false" ref="endTimerSleep" />
                </v-card-text>

                <v-card-text class="pa-5">
                    <comment-textarea v-model="dutyComment" label="Reserve Comment:" maxlength="300" />
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownReserve = false">Cancel</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_ReserveCreate"> Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>




        <!-- Begin:Content:Dialog ------------------------------------------ -->
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="grey lighten pa-5" style="color: white;">Sleeptime - Error</v-card-title>

                <v-card-text class="pa-5">
                    Sleeptime under 8 hours. Want to go anyway?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="dialog = false; agree = false;">Disagree</v-btn>
                    <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="dialog = false; agree = true;"> Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import CommentTextarea from '../../CommentTextarea.vue';

    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-reserve',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownReserve
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            Datetime,
            CommentTextarea

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            startDateSleep  : null,
            endDateSleep    : null,
            // >>> ------------------------------
            dutyComment     : null,
            // >>> ------------------------------
            dialog  : false, // Dialog: 'SleepTime under 8H'
            agree   : false,

        }), // eo function data()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Watch */
        watch: {

            agree(value) {

                if (value === true) {
                    // >>> ------------------ update
                    if (this.editorMode === 'update') {
                        this.onSave_ReserveUpdate();
                    }

                    // >>> ------------------ create
                    if (this.editorMode === 'create') {
                        this.onSave_ReserveCreate();
                    }
                }

            }, // eo agree()

        }, // eo watch{}
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownAvailable()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownReserve: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/reserve/EventEditor.vue >>> editorShownReserve get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    startDateSleep  : new Date(eventRecord.sleepFrom),
                                    endDateSleep    : new Date(eventRecord.sleepTo),
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    startDateSleep  : startDate,
                                    endDateSleep    : endDate,
                                    dutyComment     : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownReserve get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/reserve/EventEditor.vue >>> editorShownReserve set');
                    this.$emit('input', value);

                } // eo editorShownReserve set

            } // eo editorShownReserve

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updatereserve'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> created');
            eventBus.$on('updatereserve', this.onUpdate_SingleDuty); // call: modify single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updatereserve', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_SingleDuty', // Call: Modify Single Duty
                'actn_create_SingleDuty', // Call: Create Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_ReserveUpdate()
            *
            * Desc: Check SleepTime ('under 8 hours?')
            * Note: Agree in Dialog calls this Function again.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_ReserveUpdate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> onSave_ReserveUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : me.eventRecord.originalId,
                    idResource      : me.resourceId,
                    from            : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    type            : 'RES',
                    status          : 'PLANNED',
                    sleepFrom       : moment(me.startDateSleep).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    sleepTo         : moment(me.endDateSleep).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_update_SingleDuty(params);
                }

            }, // eo function onSave_ReserveUpdate()


            /*******************************************************************
            * onSave_ReserveCreate()
            *
            * Desc: Check SleepTime ('under 8 hours?')
            * Note: Agree in Dialog calls this Function again.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_ReserveCreate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> onSave_ReserveCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    idResource      : this.resourceRecord.id,
                    from            : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    type            : 'RES',
                    status          : 'PLANNED',
                    sleepFrom       : moment(me.startDateSleep).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    sleepTo         : moment(me.endDateSleep).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_SingleDuty(params);
                }

            }, // eo function onSave_ReserveCreate()



            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'updatereserve' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote
            * Note:
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response){

                let me = this,
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> onUpdate_SingleDuty');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ sleepFrom: me.startDateSleep });
                me.eventRecord.set({ sleepTo: me.endDateSleep });
                me.eventRecord.set({ dutyComment: me.dutyComment });

                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });

                // >>> Style ----------------------------------------
                if (response.dutyComment !== null) {
                    style = ' border-right: 3px dotted #000;';
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------

                if(!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor now ...
                me.editorShownReserve = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> onChange_DatePicker');
                // newDate = new Date(value);
                // newDate.setHours(23);
                // newDate.setMinutes(59);
                // me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc: Checks/Validates Params before send to Backend.
            * Note: Kind if cascading Validations.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/reserve/EventEditor.vue >>> validateParams');
                // >>> -------------------------- 'startDate bef endDate?'      // Check 1
                startDate = moment(params.from);
                endDate = moment(params.to);
                if (endDate.isBefore(startDate)) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------


                // >>> -------------------------- 'sleepFrom bef sleepTo?'      // Check 1a
                if (valid === true) {  // still valid
                    startDate = moment(params.sleepFrom);
                    endDate = moment(params.sleepTo);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Sleep EndDate must be after Sleep StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                // >>> -------------------------- 'endDate bef sleepTo?'      // Check 1ab
                if (valid === true) {  // still valid
                    startDate = moment(params.sleepTo);
                    endDate = moment(params.to);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after Sleep EndDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                // >>> -------------------------- 'over24 hours?'               // Check 2
                if (valid === true) {  // still valid
                    a = moment(me.startDate);
                    b = moment(me.endDate);
                    diffInHours = b.diff(a, 'hours');
                    if (diffInHours > 24) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Reserve may be 24h at maximum. '
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------


                // >>> -------------------------- 'under 8 hours sleep?'        // Check 3
                if (valid === true) {  // still valid
                    a = moment(me.startDateSleep);
                    b = moment(me.endDateSleep);
                    diffInHours = b.diff(a, 'hours');

                    // >>> -------------------------- shoin dialog?
                    if (diffInHours < 8 && this.agree === false) {              // not yet agreed
                        this.dialog = true;
                        valid = false;
                    } else {
                        this.agree = false;
                        this.dialog = false;
                        valid = true;
                    }
                }


                return valid;

            }, // eo function validateParams

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
